
































import { computed, defineComponent, ref } from '@vue/composition-api'

export default defineComponent({
  name: 'VSlider',

  props: {
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 10
    },
    step: {
      type: Number,
      default: 1
    },
    correct: {
      type: [Number, Array],
      required: true
    }
  },

  setup(props) {
    const value = ref(props.min)
    const answer = ref(props.min)
    const answered = ref(false)

    const updateAnswer = (e: Event) => {
      const slider = e.currentTarget as HTMLInputElement
      answer.value = parseInt(slider.value)
      answered.value = true
    }

    const answerIsCorrect = computed(() => {
      return (
        answer.value === props.correct ||
        (Array.isArray(props.correct) &&
          props.correct.indexOf(answer.value) > -1)
      )
    })

    return {
      answered,
      value,
      answer,
      updateAnswer,
      answerIsCorrect
    }
  }
})
